import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteClientType($companyId: ID!, $id: ID!) {
    deleteClientType(companyId: $companyId, id: $id) {
      clientType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
